import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';
import queryString from 'query-string';

import withWidth from '@material-ui/core/withWidth';

import { useStyles } from './styles';
import { tabRoutes } from '../../routes';
import userSlice from '../../redux/slices/userSlice';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import Tabbar from '../../components/Tabbar';
import InputsPage from '../InputsPage';
import SelectPage from '../SelectPage';
import DesignPage from '../DesignPage';
import BomPage from '../BomPage';
import SummaryPage from '../SummaryPage';
import LinkRedirect from '../LinkRedirectPage/LinkRedirect';
import { getDomain } from '../../utils/config';

const PAGES = {
	Inputs: InputsPage,
	Select: SelectPage,
	Design: DesignPage,
	BOM: BomPage,
	Summary: SummaryPage,
	Redirect: LinkRedirect
};

const App = ({ width, ...props }) => {
	const classes = useStyles();
	const domain = getDomain();
	const [appVersion, setAppVersion] = useState('');
	const userId = useSelector(state => state.user.id);
	const dispatch = useDispatch();
	const search = queryString.parse(props.location.search);

	useEffect(() => {
		const ac = new AbortController();

		axios
			.get('api/auth')
			.then(response => {
				const obj = response.data;

				if (obj) {
					dispatch(
						userSlice.actions.logIn({
							id: obj.userId,
							name: obj.firstName + ' ' + obj.lastName,
							email: obj.email
						})
					);
				}
			})
			.catch(() => {});

		axios
			.get('api/appVersion')
			.then(response => {
				setAppVersion(response.data);
			})
			.catch(() => {});

		return () => ac.abort();
	}, [dispatch]);

	const logIn = () => {
		window.open(`https://www.${domain}/sso/dt?referer=` + window.location.href, '_self');
	};

	const logOut = () => {
		axios
			.post('api/logout', queryString.stringify({ userId }))
			.then(response => {
				if (response.data) {
					dispatch(userSlice.actions.logOut());
				}
			})
			.catch(() => {});
	};

	return (
		<Fragment>
			<Navbar screenWidth={width} appVersion={appVersion} logIn={logIn} logOut={logOut} />
			<Tabbar screenWidth={width} />

			<main className={classes.main}>
				<Switch>
					<Route path="/linksRedirect" render={() => <LinkRedirect />} />
					<Redirect exact from="/" to={tabRoutes.find(route => route.name === 'Inputs').path} />
					{tabRoutes.map(route => {
						const Page = PAGES[route.name];

						return (
							<Route
								path={route.path}
								render={() => <Page search={search} screenWidth={width} />}
								key={route.name + route.path}
							/>
						);
					})}
				</Switch>
			</main>

			<Footer screenWidth={width} appVersion={appVersion} />
		</Fragment>
	);
};

App.propTypes = {
	width: PropTypes.number.isRequired
};

export default withWidth()(App);
